module.exports = __webpack_public_path__ + "static/img/nav_logo.139b6343.png";